"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbUtils = require("ykb-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledNumericInput = require("./StyledNumericInput");
var _ValidationTooltip = _interopRequireDefault(require("./ValidationTooltip"));
var _excluded = ["step", "min", "max", "precision", "parse", "format", "mobile", "snap", "value", "type", "style", "defaultValue", "onInvalid", "onValid", "strict", "hideSpinner", "theme", "inputRef", "disabled", "readOnly", "customAddonAfter"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var KEYCODE_UP = 38;
var KEYCODE_DOWN = 40;
var IS_BROWSER = typeof document !== 'undefined';
var RE_NUMBER = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
var RE_INCOMPLETE_NUMBER = /^([+-]|\.0*|[+-]\.0*|[+-]?\d+\.)?$/;
var ZERO_NUMBERS = /-0.[0-9]*$/;

/**
 * Just a simple helper to provide support for older IEs. This is not exactly a
 * polyfill for classList.add but it does what we need with minimal effort.
 * Works with single className only!
 */
function addClass(element, className) {
  if (element.classList) {
    return element.classList.add(className);
  }
  if (!element.className.search(new RegExp('\\b' + className + '\\b'))) {
    element.className = ' ' + className;
  }
}

/**
 * Just a simple helper to provide support for older IEs. This is not exactly a
 * polyfill for classList.remove but it does what we need with minimal effort.
 * Works with single className only!
 */
function removeClass(element, className) {
  if (element.className) {
    if (element.classList) {
      return element.classList.remove(className);
    }
    element.className = element.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
  }
}

/**
 * Lookup the object.prop and returns it. If it happens to be a function,
 * executes it with args and returns it's return value. It the prop does not
 * exist on the object, or if it equals undefined, or if it is a function that
 * returns undefined the defaultValue will be returned instead.
 * @param  {Object} object       The object to look into
 * @param  {String} prop         The property name
 * @param  {*}      defaultValue The default value
 * @param  {*[]}    args         Any additional arguments to pass to the
 *                               function (if the prop is a function).
 * @return {*}                   Whatever happens to be the return value
 */
function access(object, prop, defaultValue) {
  var result = object[prop];
  if (typeof result === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }
    result = result.apply(void 0, args);
  }
  return result === undefined ? defaultValue : result;
}
var NumericInput = /*#__PURE__*/function (_Component) {
  /**
   * Set the initial state and bind this.stop to the instance.
   */
  function NumericInput() {
    var _this;
    (0, _classCallCheck2.default)(this, NumericInput);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this = _callSuper(this, NumericInput, [].concat(args));
    _this._isStrict = _this.props.strict !== false;
    _this.state = _objectSpread({
      // selectionStart: null,
      // selectionEnd  : null,
      btnDownHover: false,
      btnDownActive: false,
      btnUpHover: false,
      btnUpActive: false,
      inputFocus: false,
      // value         : null,
      stringValue: '',
      visibleValidationTooltip: false
    }, _this._propsToState(_this.props));
    _this.stop = _this.stop.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(NumericInput, _Component);
  return (0, _createClass2.default)(NumericInput, [{
    key: "_propsToState",
    value: function _propsToState(props) {
      var out = {};
      var stateStingValue = this.state ? this.state.stringValue : undefined;
      if (props.hasOwnProperty('value')) {
        if (!(0, _ykbUtils.isNullOrUndefined)(stateStingValue) && stateStingValue != String(this.state.value) && stateStingValue.includes('.') && !String(props.value).includes('.')) {
          out.stringValue = String(stateStingValue || stateStingValue === 0 ? stateStingValue : '').trim();
        } else {
          out.stringValue = String(props.value || props.value === 0 ? props.value : '').trim();
        }
        out.value = out.stringValue !== '' ? this._parse(props.value) : null;
      } else if (!this._isMounted && props.hasOwnProperty('defaultValue')) {
        out.stringValue = String(props.defaultValue || props.defaultValue === 0 ? props.defaultValue : '').trim();
        out.value = props.defaultValue !== '' ? this._parse(props.defaultValue) : null;
      }
      return out;
    }

    /**
     * Special care is taken for the "value" prop:
     * - If not provided - set it to null
     * - If the prop is a number - use it as is
     * - Otherwise:
     *     1. Convert it to string (falsy values become "")
     *     2. Then trim it.
     *     3. Then parse it to number (delegating to this.props.parse if any)
     */
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var _this2 = this;
      this._isStrict = props.strict !== false;
      var nextState = this._propsToState(props);
      if (Object.keys(nextState).length) {
        this._ignoreValueChange = true;
        this.setState(nextState, function () {
          _this2._ignoreValueChange = false;
        });
      }
    }

    /**
     * Save the input selection right before rendering
     */
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
      this.saveSelection();
    }

    /**
     * After the component has been rendered into the DOM, do whatever is
     * needed to "reconnect" it to the outer world, i.e. restore selection,
     * call some of the callbacks, validate etc.
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Call the onChange if needed. This is placed here because there are
      // many reasons for changing the value and this is the common place
      // that can capture them all
      if (!this._ignoreValueChange &&
      // no onChange if re-rendered with different value prop
      prevState.value !== this.state.value && (
      // no onChange if the value remains the same
      !isNaN(this.state.value) || this.state.value === null) // only if changing to number or null
      ) {
        this._invokeEventCallback('onChange', this.state.value, this.input.value, this.input);
      }

      // focus the input is needed (for example up/down buttons set
      // this.state.inputFocus to true)
      if (this.state.inputFocus) {
        this.input.focus();

        // Restore selectionStart (if any)
        if (this.state.selectionStart || this.state.selectionStart === 0) {
          this.input.selectionStart = this.state.selectionStart;
        }

        // Restore selectionEnd (if any)
        if (this.state.selectionEnd || this.state.selectionEnd === 0) {
          this.input.selectionEnd = this.state.selectionEnd;
        }
      }
      if ((this.props.max && this.state.value > this.props.max || this.props.min && this.state.value < this.props.min) && this._isStrict && !(0, _ykbUtils.isNullOrUndefined)(this.state.value)) {
        var _val = this._toNumber(this.state.value);
        this.setState({
          value: _val
        });
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(_val);
        }
      }
      this.checkValidity();
    }

    /**
     * This is used to clear the timer if any
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.stop();
      this.stopValidationTooltip();
    }

    /**
     * Adds getValueAsNumber and setValue methods to the input DOM element.
     */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      this._isMounted = true;
      this.input.getValueAsNumber = function () {
        return _this3.state.value || 0;
      };
      this.input.setValue = function (value) {
        _this3.setState({
          value: _this3._parse(value),
          stringValue: value
        });
      };

      // This is a special case! If the component has the "autoFocus" prop
      // and the browser did focus it we have to pass that to the onFocus
      if (!this.state.inputFocus && IS_BROWSER && document.activeElement === this.input) {
        this.state.inputFocus = true;
        this.input.focus();
        this._invokeEventCallback('onFocus', {
          target: this.input,
          type: 'focus'
        });
      }
      this.checkValidity();
    }

    /**
     * Saves the input selection in the state so that it can be restored after
     * updates
     */
  }, {
    key: "saveSelection",
    value: function saveSelection() {
      this.state.selectionStart = this.input.selectionStart;
      this.state.selectionEnd = this.input.selectionEnd;
    }

    /**
     * Unless noValidate is set to true, the component will check the
     * existing validation state (if any) and will toggle the "has-error"
     * CSS class on the wrapper
     */
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var valid,
        validationError = '';
      var supportsValidation = !!this.input.checkValidity;

      // noValidate
      var noValidate = !!(this.props.noValidate && this.props.noValidate != 'false');
      this.input.noValidate = noValidate;

      // If "noValidate" is set or "checkValidity" is not supported then
      // consider the element valid. Otherwise consider it invalid and
      // make some additional checks below
      valid = noValidate || !supportsValidation;
      if (valid) {
        validationError = '';
      } else {
        // In some browsers once a pattern is set it cannot be removed. The
        // browser sets it to "" instead which results in validation
        // failures...
        if (this.input.pattern === '') {
          this.input.pattern = this.props.required ? '.+' : '.*';
        }

        // Now check validity
        if (supportsValidation) {
          this.input.checkValidity();
          valid = this.input.validity.valid;
          if (!valid) {
            validationError = this.input.validationMessage;
          }
        }

        // Some browsers might fail to validate maxLength
        if (valid && supportsValidation && this.props.maxLength) {
          if (this.input.value.length > this.props.maxLength) {
            validationError = 'This value is too long';
          }
        }
      }
      validationError = validationError || (valid ? '' : this.input.validationMessage || 'Unknown Error');
      var validStateChanged = this._valid !== validationError;
      this._valid = validationError;
      if (validationError) {
        addClass(this.wrapper, 'has-error');
        if (validStateChanged) {
          this._invokeEventCallback('onInvalid', validationError, this.state.value, this.input.value);
        }
      } else {
        removeClass(this.wrapper, 'has-error');
        if (validStateChanged) {
          this._invokeEventCallback('onValid', this.state.value, this.input.value);
        }
      }
    }

    /**
     * Used internally to parse the argument x to it's numeric representation.
     * If the argument cannot be converted to finite number returns 0; If a
     * "precision" prop is specified uses it round the number with that
     * precision (no fixed precision here because the return value is float, not
     * string).
     */
  }, {
    key: "_toNumber",
    value: function _toNumber(x) {
      var n = parseFloat(x);
      if (isNaN(n) || !isFinite(n)) {
        n = 0;
      }
      if (this._isStrict) {
        var precision = access(this.props, 'precision', null, this);
        var q = Math.pow(10, precision === null ? 10 : precision);
        var _min = +access(this.props, 'min', NumericInput.defaultProps.min, this);
        var _max = +access(this.props, 'max', NumericInput.defaultProps.max, this);
        n = Math.min(Math.max(n, _min), _max);
        if (Number.isInteger(n)) n = Math.round(Math.round(n * q) / q);else n = Math.round(n * q) / q;
      }
      return n;
    }

    /**
     * This is used internally to parse any string into a number. It will
     * delegate to this.props.parse function if one is provided. Otherwise it
     * will just use parseFloat.
     * @private
     */
  }, {
    key: "_parse",
    value: function _parse(x) {
      x = String(x);
      if (x == '-' || x == '-0' || ZERO_NUMBERS.test(x)) {
        return x;
      }
      if (typeof this.props.parse === 'function') {
        return parseFloat(this.props.parse(x));
      }
      return parseFloat(x);
    }

    /**
     * This is used internally to format a number to it's display representation.
     * It will invoke the this.props.format function if one is provided.
     * @private
     */
  }, {
    key: "_format",
    value: function _format(n) {
      var _n = this._toNumber(n);
      var isExistDot = /([0-9])([\.]{1})/g.test(n);
      var precision = access(this.props, 'precision', null, this);
      var strictPrecision = !!this.props.strictPrecision;
      if (precision !== null && (_n || _n === 0) && (strictPrecision || isExistDot)) {
        _n = _n.toFixed(precision);
      }
      if (n === '-0' || ZERO_NUMBERS.test(n)) {
        _n = n;
      } else {
        _n += '';
      }
      if (this.props.format) {
        return this.props.format(_n);
      }
      return _n;
    }

    /**
     * The internal method that actually sets the new value on the input
     * @private
     */
  }, {
    key: "_step",
    value: function _step(n, callback) {
      var _isStrict = this._isStrict;
      this._isStrict = true;
      var _step = +access(this.props, 'step', NumericInput.defaultProps.step, this, n > 0 ? NumericInput.DIRECTION_UP : NumericInput.DIRECTION_DOWN);
      var _n = this._toNumber((this.state.value || 0) + _step * n);
      if (this.props.snap) {
        _n = Math.round(_n / _step) * _step;
      }
      this._isStrict = _isStrict;
      if (_n !== this.state.value) {
        this.setState({
          value: _n,
          stringValue: _n + ''
        }, callback);
        return true;
      }
      return false;
    }

    /**
     * This binds the Up/Down arrow key listeners
     */
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      args[0].persist();
      this._invokeEventCallback.apply(this, ['onKeyDown'].concat(args));
      var e = args[0];
      if (!e.isDefaultPrevented()) {
        if (e.keyCode === KEYCODE_UP) {
          e.preventDefault();
          this._step(e.ctrlKey || e.metaKey ? 0.1 : e.shiftKey ? 10 : 1);
        } else if (e.keyCode === KEYCODE_DOWN) {
          e.preventDefault();
          this._step(e.ctrlKey || e.metaKey ? -0.1 : e.shiftKey ? -10 : -1);
        } else if (this.props.precision > 0) {
          var value = this.input.value,
            length = value.length;
          if (e.keyCode === 8) {
            // backspace
            if (this.input.selectionStart == this.input.selectionEnd && this.input.selectionEnd > 0 && value.length && value.charAt(this.input.selectionEnd - 1) === '.') {
              e.preventDefault();
              this.input.selectionStart = this.input.selectionEnd = this.input.selectionEnd - 1;
            }
          } else if (e.keyCode === 46) {
            // delete
            if (this.input.selectionStart == this.input.selectionEnd && this.input.selectionEnd < length + 1 && value.length && value.charAt(this.input.selectionEnd) === '.') {
              e.preventDefault();
              this.input.selectionStart = this.input.selectionEnd = this.input.selectionEnd + 1;
            }
          } else if (e.keyCode === 190 && value.includes('.')) {
            // prevent second dot
            e.preventDefault();
          }
        } else if (this.props.integerMode) {
          if (e.keyCode === 190) e.preventDefault();
          if (this._isStrict && this.input.value.length == 1 && e.keyCode === 8) {
            e.preventDefault();
            this.input.value = '0';
            this.setState({
              value: 0
            });
          }
        }
      }
    }

    /**
     * Stops the widget from auto-changing by clearing the timer (if any)
     */
  }, {
    key: "stop",
    value: function stop() {
      if (this._timer) {
        clearTimeout(this._timer);
      }
    }

    /**
     * Increments the value with one step and the enters a recursive calls
     * after DELAY. This is bound to the mousedown event on the "up" button
     * and will be stopped on mouseout/mouseup.
     * @param {Boolean} _recursive The method is passing this to itself while
     *  it is in recursive mode.
     * @return void
     */
  }, {
    key: "increase",
    value: function increase() {
      var _this4 = this;
      var _recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      this.stop();
      this._step(1, callback);
      var _max = +access(this.props, 'max', NumericInput.defaultProps.max, this);
      if (isNaN(this.state.value) || +this.state.value < _max) {
        this._timer = setTimeout(function () {
          _this4.increase(true);
        }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
      }
    }

    /**
     * Decrements the value with one step and the enters a recursive calls
     * after DELAY. This is bound to the mousedown event on the "down" button
     * and will be stopped on mouseout/mouseup.
     * @param {Boolean} _recursive The method is passing this to itself while
     *  it is in recursive mode.
     * @return void
     */
  }, {
    key: "decrease",
    value: function decrease() {
      var _this5 = this;
      var _recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      this.stop();
      this._step(-1, callback);
      var _min = +access(this.props, 'min', NumericInput.defaultProps.min, this);
      if (isNaN(this.state.value) || +this.state.value > _min) {
        this._timer = setTimeout(function () {
          _this5.decrease(true);
        }, _recursive ? NumericInput.SPEED : NumericInput.DELAY);
      }
    }

    /**
     * Handles the mousedown event on the up/down buttons. Changes The
     * internal value and sets up a delay for auto increment/decrement
     * (until mouseup or mouseleave)
     */
  }, {
    key: "onMouseDown",
    value: function onMouseDown(dir, callback) {
      if (dir == 'down') {
        this.decrease(false, callback);
      } else if (dir == 'up') {
        this.increase(false, callback);
      }
    }

    /**
     * Handles the touchstart event on the up/down buttons. Changes The
     * internal value and DOES NOT sets up a delay for auto increment/decrement.
     * Note that this calls e.preventDefault() so the event is not used for
     * creating a virtual mousedown after it
     */
  }, {
    key: "onTouchStart",
    value: function onTouchStart(dir, e) {
      e.preventDefault();
      if (dir == 'down') {
        this.decrease();
      } else if (dir == 'up') {
        this.increase();
      }
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      e.preventDefault();
      this.stop();
    }

    /**
     * Helper method to invoke event callback functions if they are provided
     * in the props.
     * @param {String} callbackName The name of the function prop
     * @param {*[]} args Any additional argument are passed thru
     */
  }, {
    key: "_invokeEventCallback",
    value: function _invokeEventCallback(callbackName) {
      if (typeof this.props[callbackName] === 'function') {
        var _this$props$callbackN;
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        (_this$props$callbackN = this.props[callbackName]).call.apply(_this$props$callbackN, [null].concat(args));
      }
    }
  }, {
    key: "handleValidationTooltip",
    value: function handleValidationTooltip() {
      var _this6 = this;
      var value = this.input.value;
      var isNotValidNumber = value && !RE_NUMBER.test(value) && !RE_INCOMPLETE_NUMBER.test(value);
      if (this.props.strict) {
        this.stopValidationTooltip();
        if (isNotValidNumber) {
          this.handleVisibleValidationTooltip(true);
          this.validationTooltipTimeoutID = setTimeout(function () {
            _this6.handleVisibleValidationTooltip(false);
            _this6.stopValidationTooltip();
          }, 3000);
        } else {
          this.handleVisibleValidationTooltip(false);
        }
      }
    }
  }, {
    key: "handleVisibleValidationTooltip",
    value: function handleVisibleValidationTooltip(visible) {
      if (this.state.visibleValidationTooltip !== visible) {
        this.setState({
          visibleValidationTooltip: visible
        });
      }
    }
  }, {
    key: "stopValidationTooltip",
    value: function stopValidationTooltip() {
      if (this.validationTooltipTimeoutID) {
        clearTimeout(this.validationTooltipTimeoutID);
      }
    }

    /**
     * Renders an input wrapped in relative span and up/down buttons
     * @return {Component}
     */
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var props = this.props;
      var state = this.state;
      var css = {};
      var _this$props = this.props,
        step = _this$props.step,
        min = _this$props.min,
        max = _this$props.max,
        precision = _this$props.precision,
        parse = _this$props.parse,
        format = _this$props.format,
        mobile = _this$props.mobile,
        snap = _this$props.snap,
        value = _this$props.value,
        type = _this$props.type,
        style = _this$props.style,
        defaultValue = _this$props.defaultValue,
        onInvalid = _this$props.onInvalid,
        onValid = _this$props.onValid,
        strict = _this$props.strict,
        hideSpinner = _this$props.hideSpinner,
        theme = _this$props.theme,
        _inputRef = _this$props.inputRef,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        customAddonAfter = _this$props.customAddonAfter,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);

      // Build the styles
      for (var x in NumericInput.style) {
        css[x] = Object.assign({}, NumericInput.style[x], style ? style[x] || {} : {});
      }
      var hasFormControl = props.className && /\bform-control\b/.test(props.className);
      if (mobile == 'auto') {
        mobile = IS_BROWSER && 'ontouchstart' in document;
      }
      if (typeof mobile === 'function') {
        mobile = mobile.call(this);
      }
      mobile = !!mobile;
      var showAddOn = disabled || !readOnly;
      var attrs = {
        wrap: {
          style: style === false ? null : css.wrap,
          //ref: 'wrapper',
          ref: function ref(node) {
            _this7.wrapper = node;
          },
          onMouseUp: undefined,
          onMouseLeave: undefined
        },
        input: _objectSpread({
          inputRef: function inputRef(node) {
            _this7.input = node;
            if (_inputRef) {
              _inputRef(node);
            }
          },
          type: 'text',
          readOnly: readOnly,
          disabled: disabled,
          style: style === false ? null : Object.assign({}, css.input, !hasFormControl ? css['input:not(.form-control)'] : {}, state.inputFocus ? css['input:focus'] : {})
        }, rest),
        btnUp: {
          onMouseEnter: undefined,
          onMouseDown: undefined,
          onMouseUp: undefined,
          onMouseLeave: undefined,
          onTouchStart: undefined,
          onTouchEnd: undefined,
          style: style === false ? null : Object.assign({}, css.btn, css.btnUp, disabled ? css['btn:disabled'] : state.btnUpActive ? css['btn:active'] : state.btnUpHover ? css['btn:hover'] : {})
        },
        btnDown: {
          onMouseEnter: undefined,
          onMouseDown: undefined,
          onMouseUp: undefined,
          onMouseLeave: undefined,
          onTouchStart: undefined,
          onTouchEnd: undefined,
          style: style === false ? null : Object.assign({}, css.btn, css.btnDown, disabled ? css['btn:disabled'] : state.btnDownActive ? css['btn:active'] : state.btnDownHover ? css['btn:hover'] : {})
        }
      };
      var stringValue = String(
      // if state.stringValue is set and not empty
      state.stringValue || (
      // else if state.value is set and not null|undefined
      state.value || state.value === 0 ? state.value : '') ||
      // or finally use ""
      '');
      // incomplete number
      if (!RE_NUMBER.test(stringValue) && this.props.integerMode) {
        attrs.input.value = (0, _ykbUtils.isNullOrUndefined)(state.value) || isNaN(state.value) ? '' : this._format(state.value);
      } else if (RE_INCOMPLETE_NUMBER.test(stringValue)) {
        attrs.input.value = stringValue;
      } else if (!this._isStrict && stringValue && !RE_NUMBER.test(stringValue)) {
        // Not a number and not empty (loose mode only)
        attrs.input.value = stringValue;
      } else if (state.value || state.value === 0) {
        // number
        attrs.input.value = this._format(stringValue);
      } else {
        // empty
        attrs.input.value = '';
      }
      if (hasFormControl && style !== false) {
        Object.assign(attrs.wrap.style, css['wrap.hasFormControl']);
      }

      // mobile
      if (mobile && style !== false) {
        Object.assign(attrs.input.style, css['input.mobile']);
        Object.assign(attrs.btnUp.style, css['btnUp.mobile']);
        Object.assign(attrs.btnDown.style, css['btnDown.mobile']);
      }

      // Attach event listeners if the widget is not disabled
      if (!disabled) {
        Object.assign(attrs.wrap, {
          onMouseUp: this.stop,
          onMouseLeave: this.stop
        });
        Object.assign(attrs.btnUp, {
          onTouchStart: this.onTouchStart.bind(this, 'up'),
          onTouchEnd: this.onTouchEnd,
          onMouseEnter: function onMouseEnter() {
            _this7.setState({
              btnUpHover: true
            });
          },
          onMouseLeave: function onMouseLeave() {
            _this7.stop();
            _this7.setState({
              btnUpHover: false,
              btnUpActive: false
            });
          },
          onMouseUp: function onMouseUp() {
            _this7.setState({
              btnUpHover: true,
              btnUpActive: false
            });
          },
          onMouseDown: function onMouseDown() {
            for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = arguments[_key5];
            }
            args[0].preventDefault();
            args[0].persist();
            _this7.setState({
              btnUpHover: true,
              btnUpActive: true,
              inputFocus: true
            }, function () {
              _this7._invokeEventCallback.apply(_this7, ['onFocus'].concat(args));
              _this7.onMouseDown('up');
            });
          }
        });
        Object.assign(attrs.btnDown, {
          onTouchStart: this.onTouchStart.bind(this, 'down'),
          onTouchEnd: this.onTouchEnd,
          onMouseEnter: function onMouseEnter() {
            _this7.setState({
              btnDownHover: true
            });
          },
          onMouseLeave: function onMouseLeave() {
            _this7.stop();
            _this7.setState({
              btnDownHover: false,
              btnDownActive: false
            });
          },
          onMouseUp: function onMouseUp() {
            _this7.setState({
              btnDownHover: true,
              btnDownActive: false
            });
          },
          onMouseDown: function onMouseDown() {
            for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
              args[_key6] = arguments[_key6];
            }
            args[0].preventDefault();
            args[0].persist();
            _this7.setState({
              btnDownHover: true,
              btnDownActive: true,
              inputFocus: true
            }, function () {
              _this7._invokeEventCallback.apply(_this7, ['onFocus'].concat(args));
              _this7.onMouseDown('down');
            });
          }
        });
        Object.assign(attrs.input, {
          onChange: function onChange(e) {
            var original = e.target && e.target.value;
            var val = _this7._parse(original);
            if (val == '-' || val == '-0' || ZERO_NUMBERS.test(val)) {
              _this7.setState({
                value: val,
                stringValue: original
              });
            } else {
              if (isNaN(val)) {
                val = null;
              }
              _this7.setState({
                // allowClear ile input boşaltıldığında min değerin setlenmemesi için null kontrolü eklendi.
                value: _this7._isStrict && val !== null ? _this7._toNumber(val) : val,
                stringValue: original
              });
            }
          },
          onKeyDown: this._onKeyDown.bind(this),
          onInput: function onInput() {
            _this7.saveSelection();
            for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
              args[_key7] = arguments[_key7];
            }
            _this7._invokeEventCallback.apply(_this7, ['onInput'].concat(args));
            _this7.handleValidationTooltip();
          },
          onSelect: function onSelect() {
            _this7.saveSelection();
            for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              args[_key8] = arguments[_key8];
            }
            _this7._invokeEventCallback.apply(_this7, ['onSelect'].concat(args));
          },
          onFocus: function onFocus() {
            for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
              args[_key9] = arguments[_key9];
            }
            args[0].persist();
            _this7.setState({
              inputFocus: true
            }, function () {
              var val = _this7._parse(args[0].target.value);
              var calculateValuesContainZeros = args[0].target.value == '-0' || ZERO_NUMBERS.test(args[0].target.value) ? args[0].target.value : val + '';
              _this7.setState({
                value: val,
                stringValue: val || val === 0 ? calculateValuesContainZeros : ''
              }, function () {
                _this7._invokeEventCallback.apply(_this7, ['onFocus'].concat(args));
              });
            });
          },
          onBlur: function onBlur() {
            for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
              args[_key10] = arguments[_key10];
            }
            var _isStrict = _this7._isStrict;
            _this7._isStrict = true;
            args[0].persist();
            _this7.setState({
              inputFocus: false
            }, function () {
              var val = _this7._parse(args[0].target.value);
              var _event = _objectSpread({}, args[0]);
              if (!isNaN(val)) {
                _event = _objectSpread(_objectSpread({}, _event), {}, {
                  target: _objectSpread(_objectSpread({}, _event.target), {}, {
                    value: val
                  })
                });
              }
              var stringVal = stringValue;
              var isOnlyZero = /([0])([.0])+/.test(stringVal);
              var isThereAfterDot = /([\.]([0-9]){1,})/.test(stringVal);
              stringVal = isOnlyZero && val === 0 ? '0' : stringValue;
              stringVal = !isThereAfterDot ? stringValue.replace('.', '') : stringValue;
              _this7.setState({
                value: val,
                stringValue: stringVal
              }, function () {
                _this7._invokeEventCallback('onBlur', _event);
                _this7._isStrict = _isStrict;
              });
            });
          }
        });
      } else {
        if (style !== false) {
          Object.assign(attrs.input.style, css['input:disabled']);
        }
      }
      if (mobile) {
        var addonBefore = null;
        var addonAfter = null;
        if (!hideSpinner) {
          addonBefore = /*#__PURE__*/_react.default.createElement(_StyledNumericInput.MobileControlButton, (0, _extends2.default)({
            size: props.size,
            disabled: disabled,
            theme: theme
          }, attrs.btnDown), /*#__PURE__*/_react.default.createElement(_Icon.default, {
            name: "minus"
          }));
          addonAfter = /*#__PURE__*/_react.default.createElement(_StyledNumericInput.MobileControlButton, (0, _extends2.default)({
            size: props.size,
            disabled: disabled,
            theme: theme
          }, attrs.btnUp), /*#__PURE__*/_react.default.createElement(_Icon.default, {
            name: "plus"
          }));
        }
        return /*#__PURE__*/_react.default.createElement(_ValidationTooltip.default, {
          visible: this.state.visibleValidationTooltip
        }, /*#__PURE__*/_react.default.createElement("span", attrs.wrap, /*#__PURE__*/_react.default.createElement(_StyledNumericInput.StyledNumericInput, (0, _extends2.default)({}, attrs.input, {
          mobile: true,
          $hideSpinner: hideSpinner,
          $customAddonAfter: customAddonAfter,
          transparentAddons: true,
          focusAll: true,
          addonBefore: showAddOn && addonBefore,
          addonAfter: showAddOn && addonAfter,
          theme: theme
        }))));
      }
      var addons = null;
      if (!hideSpinner) {
        addons = /*#__PURE__*/_react.default.createElement(_StyledNumericInput.NumberInputAddonContainer, {
          size: props.size,
          theme: theme
        }, /*#__PURE__*/_react.default.createElement(_StyledNumericInput.NumberInputControlButtonUp, (0, _extends2.default)({
          size: props.size,
          theme: theme,
          disabled: disabled,
          $backgroundColorType: props.backgroundColorType
        }, attrs.btnUp), /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "sort-up"
        })), /*#__PURE__*/_react.default.createElement(_StyledNumericInput.NumberInputControlButtonDown, (0, _extends2.default)({
          size: props.size,
          theme: theme,
          disabled: disabled,
          $backgroundColorType: props.backgroundColorType
        }, attrs.btnDown), /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "sort-down"
        })));
      }
      return /*#__PURE__*/_react.default.createElement(_ValidationTooltip.default, {
        visible: this.state.visibleValidationTooltip
      }, /*#__PURE__*/_react.default.createElement("span", attrs.wrap, /*#__PURE__*/_react.default.createElement(_StyledNumericInput.StyledNumericInput, (0, _extends2.default)({}, attrs.input, {
        mobile: false,
        $hideSpinner: hideSpinner,
        $customAddonAfter: customAddonAfter,
        transparentAddons: true,
        focusAll: true,
        addonAfter: showAddOn && addons,
        theme: theme
      }))));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(NumericInput, "propTypes", {
  step: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  min: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  max: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  precision: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  strictPrecision: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  parse: _propTypes.default.func,
  format: _propTypes.default.func,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  snap: _propTypes.default.bool,
  hideSpinner: _propTypes.default.bool,
  noValidate: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
  type: _propTypes.default.string,
  pattern: _propTypes.default.string,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onInvalid: _propTypes.default.func,
  onValid: _propTypes.default.func,
  onInput: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  strict: _propTypes.default.bool,
  backgroundColorType: _propTypes.default.oneOf(['primary', 'default']),
  customAddonAfter: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  mobile: function mobile(props, propName) {
    var prop = props[propName];
    if (prop !== true && prop !== false && prop !== 'auto' && typeof prop !== 'function') {
      return new Error('The "mobile" prop must be true, false, "auto" or a function');
    }
  }
});
/**
 * The default behavior is to start from 0, use step of 1 and display
 * integers
 */
(0, _defineProperty2.default)(NumericInput, "defaultProps", {
  step: 1,
  min: -9007199254740991,
  max: 9007199254740991,
  precision: null,
  strictPrecision: false,
  parse: null,
  format: null,
  mobile: 'auto',
  strict: true,
  style: {},
  backgroundColorType: 'default'
});
/**
 * When click and hold on a button - the speed of auto changing the value.
 * This is a static property and can be modified if needed.
 */
(0, _defineProperty2.default)(NumericInput, "SPEED", 50);
/**
 * When click and hold on a button - the delay before auto changing the value.
 * This is a static property and can be modified if needed.
 */
(0, _defineProperty2.default)(NumericInput, "DELAY", 500);
/**
 * The constant indicating up direction (or increasing in general)
 */
(0, _defineProperty2.default)(NumericInput, "DIRECTION_UP", 'up');
/**
 * The constant indicating down direction (or decreasing in general)
 */
(0, _defineProperty2.default)(NumericInput, "DIRECTION_DOWN", 'down');
var _default = exports.default = NumericInput;